import Model from "../Model";

class ComercialsByDivision extends Model{

    buildUrl ({ param }) {
        return ['companyview/getgroupbydivision', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialsByDivision;